import React, { useContext } from 'react';
import classNames from 'classnames';
import styles from './StickyFooter.module.scss';
import { ArchivedPreviewContext } from './ArchivedPreviewContext';

export interface StickyFooterProps {
  /** Content rendered on the left side (status, banner, info). */
  left?: React.ReactNode;
  /** Content rendered on the right side (primary actions). */
  right?: React.ReactNode;
  /** Escape hatch — when provided, replaces left/right and renders flat. */
  children?: React.ReactNode;
  className?: string;
  /**
   * Pied propre à un import archivé (« Désarchiver »). Dans un aperçu archivé,
   * tous les autres pieds sont masqués (cf. ArchivedPreviewContext).
   */
  archivedFooter?: boolean;
}

/**
 * Sticky footer that pins to the bottom of its scroll container.
 * Use the `left` slot for status/banner content and the `right`
 * slot for primary action buttons.
 */
export function StickyFooter({
  left,
  right,
  children,
  className,
  archivedFooter = false,
}: StickyFooterProps) {
  const { archived } = useContext(ArchivedPreviewContext);
  if (archived && !archivedFooter) return null;
  return (
    <div className={classNames(styles.stickyFooter, className)}>
      {children !== undefined ? (
        children
      ) : (
        <>
          <div className={styles.left}>{left}</div>
          <div className={styles.right}>{right}</div>
        </>
      )}
    </div>
  );
}
